import { Component, Injector, OnInit } from '@angular/core';
import { Annotation, AnnotationsProvider } from '@modeso/aumico-lib-cpmm-fe';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { BasePageComponent } from '../../../pages/base.page';

@UntilDestroy()
@Component({
    selector: 'annotations.page',
    templateUrl: './annotations.page.html',
    styleUrls: ['./annotations.page.scss'],
})
export class AnnotationsPage extends BasePageComponent implements OnInit {
    constructor(private injector: Injector, private readonly annotationsProvider: AnnotationsProvider) {
        super(injector);
        this.annotationsProvider.dispatchGetTaskAnnotations(this.taskId, this.page, this.limit);
    }

    private taskId = '681b49b6c4ddadb251f72e6b';
    public taskAnnotations: Annotation[] = [];
    private page = 1;
    private limit = 50;
    public totalCount = 0;

    override ngOnInit(): void {
        super.ngOnInit();

        this.annotationsProvider
            .getTaskAnnotations$()
            .pipe(untilDestroyed(this))
            .subscribe((annotations) => {
                this.taskAnnotations = annotations;
            });

        this.annotationsProvider
            .getTaskAnnotationsCount$()
            .pipe(untilDestroyed(this))
            .subscribe((totalCount) => {
                this.totalCount = totalCount;
            });

        this.annotationsProvider
            .getPageNumber$()
            .pipe(untilDestroyed(this))
            .subscribe((page) => {
                this.page = page;
                this.annotationsProvider.dispatchGetTaskAnnotations(this.taskId, this.page, this.limit);
            });
    }

    public loadMore(): void {
        this.page++;
        this.annotationsProvider.setPageNumber(this.page);
        this.annotationsProvider.dispatchGetTaskAnnotations(this.taskId, this.page, this.limit);
    }

    public deleteAnnotation(annotationId: string): void {
        this.annotationsProvider.dispatchDeleteAnnotation(annotationId);
    }

    public createAnnotation(): void {
        this.annotationsProvider.dispatchCreateAnnotation(this.taskId, {
            content: 'annotation content',
            taskName: 'annotation content',
        });
    }

    public updateAnnotation(annotationId: string): void {
        this.annotationsProvider.dispatchUpdateAnnotation(annotationId, {
            content: 'updated annotation content',
            taskName: 'updated annotation content',
        });
    }
}
